// extracted by mini-css-extract-plugin
module.exports = {"info":"artist-about_info_3oMtl","socialMedia":"artist-about_socialMedia_1Gdzz","iconContainer":"artist-about_iconContainer_3Ji_9","icon":"artist-about_icon_1OiR2"};